import * as React from 'react';
const SvgPlatinumBadge = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={35}
        height={45}
        fill="none"
        {...props}
    >
        <path fill="#ababab" d="M0 29.647V0h35v29.647L17.246 45 0 29.647Z" />
        <g clipPath="url(#b)">
            <path
                fill="#fff"
                d="M23.463 11.753a1.189 1.189 0 0 0-.806-.32H12.332c-.302 0-.587.118-.806.32l-4.163 3.961a1.17 1.17 0 0 0-.033 1.662l9.317 9.821c.218.235.537.37.856.37.319 0 .638-.135.856-.37l9.317-9.82c.454-.47.42-1.21-.033-1.663l-4.18-3.961Zm1.343 5.22-6.447 6.8c-.319.335-.873.1-.873-.353v-9.15c0-.285.218-.503.504-.503h3.979c.134 0 .252.05.352.134l2.468 2.35c.201.202.201.521.017.723Z"
            />
        </g>
        <defs>
            <clipPath id="b">
                <path fill="#fff" d="M7 9h21v21H7z" />
            </clipPath>
        </defs>
    </svg>
);
export default SvgPlatinumBadge;
